import { c as _c } from "react/compiler-runtime";
import { getAccessLevelDescription } from "@components/access-level/access-level-utils";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { Alert, Text } from "@flat-ui";
import { FaroCoreApiUtils } from "@stellar/core-api-client";
import { useAppSelector } from "@store/store-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { nounPluralize } from "@utils/data-display";

/** Determines the content of bulk dialog and bulk success dialog for changing access level */
export function useChangeAccessLevelBulkDialogContent(type, accessLevel) {
  const $ = _c(33);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  const t0 = `Change access level for these ${type}s?`;
  const t1 = FaroCoreApiUtils.Project.AccessLevelDisplayNames[accessLevel];
  let t2;
  if ($[0] !== t1) {
    t2 = <b>{t1}</b>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2 || $[3] !== type) {
    t3 = <Text variant="bodyM">When you confirm this action, the access level of the selected{type}s will be changed to{" "}{t2}.</Text>;
    $[2] = t2;
    $[3] = type;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== accessLevel || $[6] !== type) {
    t4 = getAccessLevelDescription(type, accessLevel);
    $[5] = accessLevel;
    $[6] = type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      mt: SPACE_ELEMENTS_OF_MODAL
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4) {
    t6 = <Alert variant="info" title={t4} sx={t5} />;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[11] = t3;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t0 || $[15] !== t7) {
    t8 = {
      title: t0,
      description: t7
    };
    $[14] = t0;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const t9 = `Couldn't change the access level of ${numberOfErrors} out of ${numberOfUpdatingItems} ${type}s`;
  const t10 = `The access level of these ${type}s couldn't be changed, check the details and try again.`;
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = {
      title: t9,
      description: t10
    };
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t8 || $[22] !== type) {
    t12 = {
      initial: t8,
      failed: t11,
      confirmButtonText: "change",
      entityType: type
    };
    $[20] = t11;
    $[21] = t8;
    $[22] = type;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const bulkDialogContent = useGetBulkDialogContent(t12);
  let t13;
  if ($[24] !== numberOfSuccess || $[25] !== type) {
    t13 = nounPluralize({
      counter: numberOfSuccess,
      word: type
    });
    $[24] = numberOfSuccess;
    $[25] = type;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const t14 = `${t13} changed access level.`;
  const t15 = `The access level of all selected ${type}s was successfully changed.`;
  let t16;
  if ($[27] !== t14 || $[28] !== t15) {
    t16 = {
      title: t14,
      description: t15
    };
    $[27] = t14;
    $[28] = t15;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  const successDialogContent = t16;
  let t17;
  if ($[30] !== bulkDialogContent || $[31] !== successDialogContent) {
    t17 = {
      bulkDialogContent,
      successDialogContent
    };
    $[30] = bulkDialogContent;
    $[31] = successDialogContent;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}